/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Woodlevel1Inputs */



/**
* | output |
* | --- |
* | "Wood level" |
*
* @param {Br_History_Key_Woodlevel1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_woodlevel1 = /** @type {((inputs?: Br_History_Key_Woodlevel1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Woodlevel1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Wood level")
	return /** @type {LocalizedString} */ ("Niveau de bois")
});
export { br_history_key_woodlevel1 as "br_history_key_woodLevel" }